module.exports = __webpack_public_path__ + "media/images/envelope-8554ec1f5e99cfac1f5ff6f927df678e.gif";